import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CustomOverlayTemplateComponent } from "../custom-overlay-template/custom-overlay-template.component"

@Component({
  selector: 'app-planned-eta-column-molecule',
  templateUrl: './planned-eta-column-molecule.component.html',
  styleUrls: ['./planned-eta-column-molecule.component.scss']
})
export class PlannedEtaColumnMoleculeComponent {
  @Input() data: any;
  @Input() header: any;
  @Input() reportName: any;

  constructor(private dialog: MatDialog,){}

  onEditCobject(data: any, event: any) {
      // if (this.grid) {
      //   var position = this.grid.element.querySelectorAll('.e-movablecontent')[0].scrollLeft || 0;
      //   this.selectedIndex = +data.index;
      //   window.localStorage.setItem("selectedRowIndex", this.selectedIndex);
      //   console.log(event,"evvvvvvvvvvve")
      // }
      // this.dataSharingService.updatePosition(position);
      const dialogRef = this.dialog.open(CustomOverlayTemplateComponent, {
        width: '1000px',
        data: { parent: data.parent, location: data.location },
      });
  
      // dialogRef.afterClosed().subscribe(result => {
      //   if (result) {
      //     // if (this.syncfusion.getReload()) {
      //     //   // this.getPersistentData()
      //     //   setTimeout(() => {
      //     //     // this.restore();
      //     //   }, 5000);
      //     // }
      //   }
      // });
    }
}
